import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../apis/baseQuery';
import { API_CONSTANTS } from '../../../utils/constants';
import type {
  EventListRequest,
  EventListResponse,
  EventDetailResponse,
  EventParticipantsResponse,
} from './model/event';

export const eventsApi = createApi({
  reducerPath: 'eventsApi',
  tagTypes: ['EventList'],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getEventList: builder.query<EventListResponse, Partial<EventListRequest>>({
      query: (params = {}) => ({
        url: API_CONSTANTS.EVENTS.EVENT_LIST_URL,
        method: 'GET',
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: 'EventList' as const,
                id,
              })),
              { type: 'EventList', id: 'LIST' },
            ]
          : [{ type: 'EventList', id: 'LIST' }],
    }),
    getEventDetail: builder.query<EventDetailResponse, string | number>({
      query: (id) => ({
        url: API_CONSTANTS.EVENTS.EVENT_DETAIL_URL(id),
        method: 'GET',
      }),
    }),
    getEventParticipants: builder.query<
      EventParticipantsResponse,
      { id: string | number; page?: number; limit?: number; search?: string }
    >({
      query: ({ id, page = 1, limit = 10, search = '' }) => ({
        url: API_CONSTANTS.EVENTS.EVENT_PARTICIPANTS_URL(id),
        method: 'GET',
        params: { page, limit, search },
      }),
    }),
  }),
});

export const {
  useGetEventListQuery,
  useLazyGetEventListQuery,
  useGetEventDetailQuery,
  useGetEventParticipantsQuery,
} = eventsApi;

export default eventsApi;
